export default __webpack_public_path__ + "static/media/ICED_DXC_Logo.000da09b.png";